// import { Error } from "./Error";
// import { useFormik } from "formik";
// import { contactUs, clearError } from "../actions/general";
// import { useDispatch } from "react-redux";
// import { useNavigate } from "react-router-dom";
import { useEffect, useState } from 'react';
import * as api from '../api';
import { SERVER_URL } from '../constants/actionTypes';

export default function Careers() {
    const [team,setTeam] = useState([]);
      const [status, setStatus] = useState({ loading: false, success: null, error: null });
    // const [teamLink, setTeamLink] = useState('#');
//   const dispatch = useDispatch();
//   const history = useNavigate();

//   const formik = useFormik({
//     initialValues: {
//       name: "",
//       email: "",
//       phone: "",
//       subject: "",
//       u_message: "",
//     },
//     onSubmit: (values) => {
//       dispatch(clearError());
//       dispatch(contactUs(values, history));
//     },
//   });
  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    const formData = new FormData(form);

    setStatus({ loading: true, success: null, error: null });

    try {
      await api.joinOurTeamCall(formData);
      setStatus({ loading: false, success: 'Thanks for applying! We’ll be in touch soon.', error: null });
      form.reset(); // clear the form
    } catch (err) {
      setStatus({ loading: false, success: null, error: 'Failed to submit your application. Please try again.' });
      console.error(err);
    }
  };
useEffect(() => {
  const fetchData = async () => {
    const { data } = await api.fetchTeam();
    // const setting = await api.fetchTeamLink();
    if (Array.isArray(data.data)) {
      setTeam(data.data);
      // setTeamLink(setting?.data?.setting?.meta_value)
    } else {
      setTeam([]); // fallback in case API returns something else
      console.error('Expected array from fetchTeam, got:', data);
    }
  };

  fetchData();
}, []); // ✅ Runs once on mount
  return (
    <>
      <section className="career_section pt-10 pb-10 md:mx-0 mx-3">
        <div className="container mx-auto">
         
          <div className="abt_title max-w-4xl mx-auto">
             <h1 className="text-mydarkcolor font-primary text-center text-4xl font-bold pb-4 mb-5">
            Who We Are
          </h1>
            <p className="text-dark font-primary text-base leading-7 mb-4 text-center">
             At Wholesale Xpress, we’re more than a distributor—we’re a partner to the businesses that keep our communities moving. Specializing in convenience store and smoke shop products, we’re dedicated to delivering exceptional service, competitive pricing, and a huge selection that helps our customers thrive.
            </p>
                <p className="text-dark font-primary text-base leading-7 mb-4 text-center">
             We believe great businesses are built by great teams. At Wholesale Xpress, you’ll find a collaborative, fast-paced, and supportive environment where ideas are valued, growth is encouraged, and every employee plays an important role in our success. Whether you’re in the warehouse, on the sales team, or supporting customers, you’ll be part of a company that cares about quality, relationships, and doing the job right.
            </p>
          </div>
          <h1 className="text-mydarkcolor font-primary text-center text-4xl font-bold pb-4 mb-5 mt-10">
            Hear From Our Team
          </h1>
          <div className="grid grid-cols-1 md:grid-cols-12 p-5 gap-5 max-w-4xl mx-auto items-center">
           {team?.map((element, index) => (index % 2 === 0 ? 
               <>
               <div className="col-span-12 grid grid-cols-1 md:grid-cols-12 p-5 gap-5 max-w-4xl mx-auto items-center"> 
               <div key={index} className={`md:col-span-6 col-span-12
      order-2 md:order-1`}>
                <h5 className="text-mydarkcolor font-primary text-xl font-bold">{element.name}</h5>
                <p className="">{element.description}</p>
                </div>               
                <div className={`md:col-span-6 col-span-12 flex justify-center text-center
      order-1 md:order-2`}>
                       <img className='rounded max-h-[400px]' alt={element.name} src={SERVER_URL + element.image}/>
                
            </div></div></>: <> <div className="col-span-12 grid grid-cols-1 md:grid-cols-12 p-5 gap-5 max-w-4xl mx-auto items-center">
                         <div className={`md:col-span-6 col-span-12 flex justify-center text-center
      order-1 md:order-1`}>
                       <img className='rounded' alt={element.name} src={SERVER_URL + element.image}/>
                
            </div>
            <div key={index} className={`md:col-span-6 col-span-12
      order-2 md:order-2`}>
                <h5 className="text-mydarkcolor font-primary text-xl font-bold">{element.name}</h5>
                <p className="">{element.description}</p>
                </div>  
                </div>             
   </>


            ))}
            <div className="col-span-12">
                   <div className="abt_title max-w-4xl mx-auto text-center">
                <h1 className="text-mydarkcolor font-primary text-center text-4xl font-bold pb-4 mb-5 mt-10">Join Our Team</h1>
                <p className="text-dark font-primary text-base leading-7 mb-4 text-center">
                    We’re always looking for motivated, dependable, and customer-focused people to grow with us. If you’re ready to work hard, learn, and be part of a team that values your contribution, Wholesale Xpress could be the place for you.
                </p>
                  <form onSubmit={handleSubmit} className="text-left space-y-4 mb-10 max-w-xl mx-auto">
  <div>
    <label htmlFor="fullName" className="block text-sm font-medium text-gray-700">Full Name</label>
    <input
      type="text"
      id="fullName"
      name="fullName"
      className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-mybluecolor focus:border-mybluecolor"
      required
    />
  </div>
  
  <div>
    <label htmlFor="email" className="block text-sm font-medium text-gray-700">Email Address</label>
    <input
      type="email"
      id="email"
      name="email"
      className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-mybluecolor focus:border-mybluecolor"
      required
    />
  </div>
  
  <div>
    <label htmlFor="phone" className="block text-sm font-medium text-gray-700">Phone Number</label>
    <input
      type="tel"
      id="phone"
      name="phone"
      className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-mybluecolor focus:border-mybluecolor"
    />
  </div>

  <div>
    <label htmlFor="position" className="block text-sm font-medium text-gray-700">Position Applied</label>
    <input
      type="text"
      id="position"
      name="position"
      className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-mybluecolor focus:border-mybluecolor"
    />
  </div>

  <div>
    <label htmlFor="comments" className="block text-sm font-medium text-gray-700">Comments</label>
    <textarea
      id="comments"
      name="comments"
      rows="4"
      className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-mybluecolor focus:border-mybluecolor"
    ></textarea>
  </div>

  <div className="text-center">
    <button
      type="submit"  disabled={status.loading}
      className="bg-mybluecolor text-white text-lg px-10 py-2 rounded-full inline-block"
    >
       {status.loading ? 'Submitting...' : 'Join Our Team'}
     
    </button>
  </div>
</form>
 {/* Success or Error Message */}
      {status.success && <p style={{ color: 'green', marginTop: '10px' }}>{status.success}</p>}
      {status.error && <p style={{ color: 'red', marginTop: '10px' }}>{status.error}</p>}
                </div>
                </div>
          </div>
        </div>
      </section>
    </>
  );
}
